export const numberWithSpaces = (x: number, toFixed = 2): string => {
  const parts = x.toFixed(toFixed).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
  return parts.join('.');
};
